import React, { FC, useState, useEffect } from "react";

import {
    Row,
    Col,
    Button,
  } from "antd";

const NumberIncrementInput: React.FC<any> = ({
    value = undefined,
    onChange,
  }) => {
    const [count, setCount] = useState<number>(1);
  
    useEffect(() => {
      onChange(count);
    }, []);
  
    return (
      <Row className="mt-2 d-flex">
        <Col>
          <Button
            className="primary count-btn"
            onClick={() => {
              if (count === 0) return;
              else {
                setCount(count - 1);
                onChange(count - 1);
              }
            }}
          >
            -
          </Button>
        </Col>
        <Col>
          <p>
            {count < 10 ? "0" : ""}
            {count}
          </p>
        </Col>
        <Col>
          <Button
            className="primary count-btn"
            onClick={() => {
              setCount(count + 1);
              onChange(count + 1);
            }}
          >
            +
          </Button>
        </Col>
      </Row>
    );
  };

  export default NumberIncrementInput;